/**
 * Opening hours presets for UK dental practices.
 * Used by the smart editing UI for quick-setup and bulk operations.
 */

const WEEKDAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
const ALL_WEEK = [...WEEKDAYS, 'SATURDAY'];

function makeBlocks(startStr, endStr) {
    return [{ start_time: `${startStr}:00`, end_time: `${endStr}:00` }];
}

function makeSplitBlocks(morningStart, morningEnd, afternoonStart, afternoonEnd) {
    return [
        { start_time: `${morningStart}:00`, end_time: `${morningEnd}:00` },
        { start_time: `${afternoonStart}:00`, end_time: `${afternoonEnd}:00` },
    ];
}

export const HOUR_PRESETS = [
    {
        label: 'Mon\u2013Fri 9:00\u201317:30',
        days: Object.fromEntries(WEEKDAYS.map((d) => [d, makeBlocks('09:00', '17:30')])),
    },
    {
        label: 'Mon\u2013Fri 9\u201312, 13\u201317',
        days: Object.fromEntries(WEEKDAYS.map((d) => [d, makeSplitBlocks('09:00', '12:00', '13:00', '17:00')])),
    },
    {
        label: 'Mon\u2013Sat 8:00\u201318:00',
        days: Object.fromEntries(ALL_WEEK.map((d) => [d, makeBlocks('08:00', '18:00')])),
    },
    {
        label: 'Mon\u2013Sat 9:00\u201317:30',
        days: Object.fromEntries(ALL_WEEK.map((d) => [d, makeBlocks('09:00', '17:30')])),
    },
];

export const LUNCH_PRESETS = [
    { label: '12:00\u201313:00', start: '12:00:00', end: '13:00:00' },
    { label: '12:30\u201313:30', start: '12:30:00', end: '13:30:00' },
    { label: '13:00\u201314:00', start: '13:00:00', end: '14:00:00' },
];

export const DAY_GROUPS = [
    { label: 'All', days: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'] },
    { label: 'Weekdays', days: WEEKDAYS },
    { label: 'Weekend', days: ['SATURDAY', 'SUNDAY'] },
];

/**
 * Converts legacy single start_time/end_time to time_blocks format.
 * Graceful fallback for backends that haven't migrated yet.
 */
export function normalizeToTimeBlocks(hourRecord) {
    if (hourRecord.time_blocks && Array.isArray(hourRecord.time_blocks)) {
        return hourRecord.time_blocks;
    }
    if (hourRecord.start_time && hourRecord.end_time) {
        return [{ start_time: hourRecord.start_time, end_time: hourRecord.end_time }];
    }
    return [];
}

/**
 * Converts time_blocks back to legacy format for backends that expect it.
 */
export function timeBlocksToLegacy(timeBlocks) {
    if (!timeBlocks || timeBlocks.length === 0) {
        return { start_time: null, end_time: null };
    }
    return {
        start_time: timeBlocks[0].start_time,
        end_time: timeBlocks[timeBlocks.length - 1].end_time,
    };
}
